import { Project } from './components/pages/projects-page/default-projects';

const DB_URL = 'https://synthkitty-artus.aws-eu-west-1.turso.io';
const DB_TOKEN =
  'eyJhbGciOiJFZERTQSIsInR5cCI6IkpXVCJ9.eyJhIjoicnciLCJpYXQiOjE3NzI3OTQwODgsImlkIjoiMDE5Y2MyYzItZDkwMS03OGFlLThhYzctYjIzZTQ1N2MyYTg3IiwicmlkIjoiZjllNzI5YWItOGVkNy00NmVjLWE2ODItMzQ5NzZhZDAwYTdmIn0.wl-UcAhNzWjyxrvWsAsPKtkAPjrgExOIYEcWqs6wIRUzhku1ZbQbh20C6AAX0OQvQKRiW60Yn1mlI-TaukjIBQ';

type TursoArg =
  | { type: 'text'; value: string }
  | { type: 'integer'; value: string };

interface TursoResponse {
  results: Array<{
    type: string;
    response?: {
      type: string;
      result?: {
        rows: Array<Array<{ type: string; value: string }>>;
      };
    };
  }>;
}

async function execute(
  stmts: Array<{ sql: string; args?: TursoArg[] }>,
): Promise<TursoResponse> {
  const requests = [
    ...stmts.map(s => ({ type: 'execute', stmt: s })),
    { type: 'close' },
  ];
  const res = await fetch(`${DB_URL}/v2/pipeline`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${DB_TOKEN}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ requests }),
  });
  if (!res.ok) throw new Error(`Turso error ${res.status}: ${res.statusText}`);
  return res.json() as Promise<TursoResponse>;
}

const CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

function randomId(len = 6): string {
  return Array.from({ length: len }, () =>
    CHARS[Math.floor(Math.random() * CHARS.length)],
  ).join('');
}

export function shareUrl(id: string): string {
  return `${window.location.origin}/${id}`;
}

export async function createShare(project: Project): Promise<string> {
  const id = randomId();
  await execute([
    {
      sql: `CREATE TABLE IF NOT EXISTS shares (
              id          TEXT    PRIMARY KEY,
              project     TEXT    NOT NULL,
              created_at  INTEGER NOT NULL
            )`,
    },
    {
      sql: 'INSERT INTO shares (id, project, created_at) VALUES (?, ?, ?)',
      args: [
        { type: 'text', value: id },
        { type: 'text', value: JSON.stringify(project) },
        { type: 'integer', value: String(Date.now()) },
      ],
    },
  ]);
  return id;
}

export async function loadShare(id: string): Promise<Project | null> {
  try {
    const data = await execute([
      {
        sql: 'SELECT project FROM shares WHERE id = ?',
        args: [{ type: 'text', value: id }],
      },
    ]);
    const rows = data.results[0]?.response?.result?.rows;
    if (!rows || rows.length === 0) return null;
    return JSON.parse(rows[0][0].value) as Project;
  } catch {
    return null;
  }
}
